import { DialogContent, Modal } from "@mekidoc/ui";
import { styled } from "@mui/material";
import { ClickableProChip } from "./ProChip";

interface TrialProModalProps {
  showTrialProModal: boolean;
  setShowTrialProModal: (value: boolean) => void;
}

const StyledDialogContent = styled(DialogContent)({
  padding: "0px 0px 12px 0px",
  "& strong": {
    fontWeight: 500,
  },
});

const StyledProChip = styled(ClickableProChip)(({ theme }) => ({
  background: theme.palette.background.proChipText,
  backgroundClip: "text",
  color: "transparent",
  "&:hover": {
    transform: "none",
    "&::after": {
      display: "none",
    },
  },
}));

const StyledDialogTitle = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexWrap: "wrap",
  gap: "0px 8px",
  fontSize: "18px",
  paddingTop: "24px",
});

export const TrialProModal: React.FC<TrialProModalProps> = ({
  showTrialProModal,
  setShowTrialProModal,
}) => {
  const content = (
    <StyledDialogContent fontSize="16px">
      La sección <strong>posibles interacciones</strong> es una funcionalidad
      del plan PRO.{" "}
      <strong>Durante todo 2025 podrás acceder a ella sin costo.</strong>
    </StyledDialogContent>
  );
  const titleContent = (
    <StyledDialogTitle>
      Funcionalidad <StyledProChip elevation={0}>MekiDoc PRO</StyledProChip>
    </StyledDialogTitle>
  );
  return (
    <Modal
      isOpen={showTrialProModal}
      onClose={() => setShowTrialProModal(false)}
      title={titleContent}
      content={content}
    ></Modal>
  );
};
